/**
 * Utility function to trap keyboard focus within a modal dialog.
 */
export const trapFocusOnModal = element => {
  const focusableSelectors = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"]):not([disabled])',
    'summary'
  ].join(', ');

  const getFocusableElements = () => {
    return Array.from(element.querySelectorAll(focusableSelectors))
      .filter(el => {
        // Escludi esplicitamente input hidden e errorparam
        if (el.type === 'hidden' || el.name === 'errorparam') {
          return false;
        }

        // Eccezione per switch toggle: questi input hanno dimensioni 0 ma sono funzionali
        if (el.hasAttribute('data-switch-toggle')) {
          const style = getComputedStyle(el);
          return !el.hidden &&
                 style.visibility !== 'hidden' &&
                 style.display !== 'none' &&
                 !el.hasAttribute('inert') &&
                 !el.closest('[inert]');
        }
        
        // Filtro più rigoroso per elementi nascosti
        const style = getComputedStyle(el);
        return el.offsetWidth > 0 && 
               el.offsetHeight > 0 && 
               !el.hidden &&
               style.visibility !== 'hidden' &&
               style.display !== 'none' &&
               !el.hasAttribute('inert') &&
               !el.closest('[inert]');
      });
  };

  const keyboardNavigation = (e) => {
    const isTabPressed = e.key === "Tab";
    if (!isTabPressed) {
      return;
    }

    // Ricalcola gli elementi focusabili ad ogni Tab (in caso di cambiamenti dinamici)
    const focusableEls = getFocusableElements();
    
    
    if (focusableEls.length === 0) return;

    const firstFocusableEl = focusableEls[0];
    const lastFocusableEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) {
      // Shift + Tab - vai all'elemento precedente
      if (document.activeElement === firstFocusableEl) {
        e.preventDefault();
        lastFocusableEl.focus();
      }
    } else {
      // Tab normale - vai all'elemento successivo
      if (document.activeElement === lastFocusableEl) {
        e.preventDefault();
        firstFocusableEl.focus();
      }
    }
  };

  element.addEventListener("keydown", keyboardNavigation);

  // Restituisci la funzione per poterla rimuovere successivamente
  return keyboardNavigation;
};

export const removeTrapFocusOnModal = (element, keyboardNavigationHandler) => {
  if (keyboardNavigationHandler) {
    element.removeEventListener("keydown", keyboardNavigationHandler);
  }
};
